import { render, staticRenderFns } from "./home-commodity.vue?vue&type=template&id=7c44ea36&scoped=true&"
import script from "./home-commodity.vue?vue&type=script&lang=js&"
export * from "./home-commodity.vue?vue&type=script&lang=js&"
import style0 from "./home-commodity.vue?vue&type=style&index=0&id=7c44ea36&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44ea36",
  null
  
)

export default component.exports